import React from "react";
import "./PhotoSlider.css";
import front_lodgefreenhouse from "../images/front lodge.jpg";
import outside from "../images/outside area.jpg";
import lodgegreen from "../images/outside.jpg";

import interiorlodgegreenhouse from "../images/Interior Lodge Green house.jpg";
import interior from "../images/interior.jpg";
import reception from "../images/reception.jpg";


function PhotoSlider() {
  return (
    <div className="slider">
      <div className="slidenew-track">
        <div className="slidenew">
          <img src={front_lodgefreenhouse} alt="front_lodgefreenhouse" />
        </div>
        <div className="slidenew">
          <img src={outside} alt="lodgefront" />
        </div>
        <div className="slidenew">
          <img src={lodgegreen} alt="lodgegreenhouse" />
        </div>

        {/* Duplicate logos for smooth infinite effect */}
        <div className="slidenew">
            <img src={interiorlodgegreenhouse} alt="interior lodgegreenhouse" />
        </div>
        <div className="slidenew">
            <img src={interior} alt="interior photo" />
        </div>
        <div className="slidenew">
                 <img src={reception} alt="reception" />
        </div>
      </div>
    </div>
  );
}

export default PhotoSlider;
